/* eslint-disable max-len */
import { getRouterChildren } from '@/components/public/showcase/showcaseModules';
import publicRoutesMetaData from '@/router/publicRoutes/publicRoutesMetaData';

const Showcase = () => import(/* webpackChunkName: "showcase" */ '@/components/public/showcase/Showcase.vue');
const WebAdsModule = () => import(/* webpackChunkName: "webadsmodule" */ '@/components/modules/salesTools/webAds/WebAdsModule.vue');
const OutdoorAdsModule = () => import(/* webpackChunkName: "outdooradsmodule" */ '@/components/modules/salesTools/outdoorAds/OutdoorAdsModule.vue');
const SalesTools = () => import(/* webpackChunkName: "salestools" */ '@/components/public/sales-tools/SalesTools.vue');
const ShowcaseDefaultView = () => import(/* webpackChunkName: "showcasedefaultview" */ '@/components/public/showcase/showcase-default-view/ShowcaseDefaultView.vue');
const FacebookAdsModule = () => import(/* webpackChunkName: "facebookadsmodule" */ '@/components/modules/salesTools/facebookAds/FacebookAdsModule.vue');
const SocialSellingModule = () => import(/* webpackChunkName: "socialsellingmodule" */ '@/components/modules/salesTools/SocialSellingModule.vue');
const TrafficBoosterModule = () => import(/* webpackChunkName: "trafficboostermodule" */ '@/components/modules/salesTools/trafficBooster/TrafficBoosterModule.vue');
const ComfortPackageModule = () => import(/* webpackChunkName: "comfortpackagemodule" */ '@/components/modules/salesTools/comfortPackage/ComfortPackageModule.vue');

export default [
  {
    path: '',
    name: 'salestools',
    component: SalesTools,
    children: [
      {
        path: 'webads',
        component: WebAdsModule,
        meta: {
          eventInputComponents: publicRoutesMetaData.getEventInputComponents(true),
          postUrl: publicRoutesMetaData.getPostUrl('webads', true),
        },
      },
      {
        path: 'outdoorads',
        component: OutdoorAdsModule,
        meta: {
          eventInputComponents: publicRoutesMetaData.getEventInputComponents(true),
          postUrl: publicRoutesMetaData.getPostUrl('outdoorads', true),
        },
      },
      {
        path: 'facebookads',
        component: FacebookAdsModule,
        meta: {
          eventInputComponents: publicRoutesMetaData.getEventInputComponents(true),
          postUrl: publicRoutesMetaData.getPostUrl('facebookads', true),
        },
      },
      {
        path: 'socialselling',
        component: SocialSellingModule,
        meta: {
          eventInputComponents: publicRoutesMetaData.getEventInputComponents(true),
          postUrl: publicRoutesMetaData.getPostUrl('socialselling', true),
        },
      },
      {
        path: 'trafficbooster',
        component: TrafficBoosterModule,
        meta: {
          eventInputComponents: publicRoutesMetaData.getEventInputComponents(true),
          postUrl: publicRoutesMetaData.getPostUrl('trafficbooster', true),
        },
      },
      {
        path: 'comfortpackage',
        component: ComfortPackageModule,
        meta: {
          postUrl: publicRoutesMetaData.getPostUrl('comfort', true),
        },
      },
    ],
  },
  {
    path: '/showcase',
    component: Showcase,
    children: [
      {
        name: 'showcase',
        path: '',
        component: ShowcaseDefaultView,
      },
      ...getRouterChildren(),
    ],
  },
];
